import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "002_soft_delete_unique_indexes",
  version: "0.1.0",
  sql: `
DROP INDEX IF EXISTS \`db_company_code_idx\`;
CREATE UNIQUE INDEX IF NOT EXISTS \`db_company_code_idx\` ON \`dormitory_buildings\` (\`company_id\`, \`code\`) WHERE \`deleted_at\` IS NULL;

DROP INDEX IF EXISTS \`dr_building_room_idx\`;
CREATE UNIQUE INDEX IF NOT EXISTS \`dr_building_room_idx\` ON \`dormitory_rooms\` (\`building_id\`, \`room_no\`) WHERE \`deleted_at\` IS NULL;

DROP INDEX IF EXISTS \`dl_company_lease_no_idx\`;
CREATE UNIQUE INDEX IF NOT EXISTS \`dl_company_lease_no_idx\` ON \`dormitory_leases\` (\`company_id\`, \`lease_no\`) WHERE \`deleted_at\` IS NULL;

DROP INDEX IF EXISTS \`dbp_company_period_idx\`;
CREATE UNIQUE INDEX IF NOT EXISTS \`dbp_company_period_idx\` ON \`dormitory_billing_periods\` (\`company_id\`, \`period_month\`) WHERE \`deleted_at\` IS NULL;

DROP INDEX IF EXISTS \`dmr_period_room_meter_idx\`;
CREATE UNIQUE INDEX IF NOT EXISTS \`dmr_period_room_meter_idx\` ON \`dormitory_meter_readings\` (\`billing_period_id\`, \`room_id\`, \`meter_type\`) WHERE \`deleted_at\` IS NULL;

DROP INDEX IF EXISTS \`dbill_company_bill_no_idx\`;
CREATE UNIQUE INDEX IF NOT EXISTS \`dbill_company_bill_no_idx\` ON \`dormitory_bills\` (\`company_id\`, \`bill_no\`) WHERE \`deleted_at\` IS NULL;

DROP INDEX IF EXISTS \`dbill_period_lease_idx\`;
CREATE UNIQUE INDEX IF NOT EXISTS \`dbill_period_lease_idx\` ON \`dormitory_bills\` (\`billing_period_id\`, \`lease_id\`) WHERE \`deleted_at\` IS NULL;
  `.trim(),
};
